import React from 'react';
import { Popconfirm } from 'antd';
import { useDeleteResponseTemplate } from '../../api';

const DeleteBtn = ({ render, item }) => {
  const { deleteTemplate } = useDeleteResponseTemplate();

  return (
    <Popconfirm
      cancelText="Нет"
      okText="Да"
      onConfirm={(e) => {
        e.stopPropagation();
        deleteTemplate({ templateId: item.id });
      }}
      title="Удалить шаблон?"
      placement="bottom"
    >
      {render()}
    </Popconfirm>
  );
};

export default DeleteBtn;
